import { configureStore } from '@reduxjs/toolkit';

import { commentsApi } from '@/services/comments';
import { contactsApi } from '@/services/contacts';
import { coursesApi } from '@/services/course';
import { inviteApi } from '@/services/invites';
import { lessonsApi } from '@/services/lesson';
import { notesApi } from '@/services/notes';
import { notificationApi } from '@/services/notifications';
import { packageApi } from '@/services/package';
import { resumeApi } from '@/services/resume';
import { savedLessonApi } from '@/services/savedLessons';
import { shelvesApi } from '@/services/shelves';
import { userApi } from '@/services/user';

import auth from './auth/slice';
import drawer from './drawer/slice';
import notification from './notification/slice';
import theme from './theme/slice';

export const store = configureStore({
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat([
      notificationApi.middleware,
      resumeApi.middleware,
      coursesApi.middleware,
      lessonsApi.middleware,
      notesApi.middleware,
      contactsApi.middleware,
      commentsApi.middleware,
      inviteApi.middleware,
      savedLessonApi.middleware,
      userApi.middleware,
      shelvesApi.middleware,
      packageApi.middleware
    ]),
  reducer: {
    drawer,
    auth,
    theme,
    notification,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [savedLessonApi.reducerPath]: savedLessonApi.reducer,
    [resumeApi.reducerPath]: resumeApi.reducer,
    [coursesApi.reducerPath]: coursesApi.reducer,
    [lessonsApi.reducerPath]: lessonsApi.reducer,
    [notesApi.reducerPath]: notesApi.reducer,
    [contactsApi.reducerPath]: contactsApi.reducer,
    [commentsApi.reducerPath]: commentsApi.reducer,
    [inviteApi.reducerPath]: inviteApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [shelvesApi.reducerPath]: shelvesApi.reducer,
    [packageApi.reducerPath]: packageApi.reducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
